import { makeStyles } from 'tss-react/mui';

export const useOrderSlidesChartHeaderStyles = makeStyles()(() => ({
  header: { alignItems: 'center', display: 'flex', gap: '0.5rem' },
  source: { marginLeft: 'auto' },
}));
